<div class="draggable p-8" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
  <div class="content flex flex-col border-a-12 bg-base-white rounded">
    <header
      class="flex flex-row flex-nowrap items-center max-w-full gap-8 rounded p-8 text-primary bg-base-white dark:bg-base-black select-none"
    >
      <mat-icon class="drag-handle" svgIcon="icon_drag_16" />
      <div class="title">{{ title }}</div>
      <div class="buttons ml-auto">
        <button blazeIconButton data-cy="VisualEffectConfigDialog:close" (click)="close()">
          <mat-icon svgIcon="icon_close_16" />
        </button>
      </div>
    </header>

    <div class="dialog-content">
      <div class="controls" [formGroup]="form">
        <div class="flex gap-16 mb-12">
          <label class="control-inline">
            <span>X</span>
            <input type="number" formControlName="effectX" />
          </label>
          <label class="control-inline">
            <span>Y</span>
            <input type="number" formControlName="effectY" />
          </label>
          <label class="control-inline ml-auto">
            <span>Blur</span>
            <input type="number" formControlName="effectBlur" />
          </label>
        </div>
        <label class="control-color">
          <span>Color</span>
          <blaze-color-picker formControlName="effectColor1" />
        </label>
      </div>
    </div>
  </div>
</div>
